import request from '../request';
import { url } from '../urlConfig';
const server = {
  uploadFilingApplyFile() {
    return `${url.base}/user-center/oss/uploadFilingApplyFile`;
  },
  // 资源备案管理-申请备案
  addFilingApply: function (params) {
    return request.post('/user-center/resourceFiling/addFilingApply', params);
  },
  // 资源备案管理-备案批量审核校验
  checkFilingAudit: function (params) {
    return request.post('/user-center/resourceFiling/checkFilingAudit', params);
  },
  // 资源备案管理-申请备案校验
  checkFilingApply: function (params) {
    return request.post('/user-center/resourceFiling/checkFilingApply', params);
  },
  // 资源备案管理-备案申请初审
  dealApplyFirstAudit: function (params) {
    return request.post(
      '/user-center/resourceFiling/dealApplyFirstAudit',
      params,
      { preventRepeat: false }
    );
  },
  // 复审
  dealApplySecondAudit: function (params) {
    return request.post(
      '/user-center/resourceFiling/dealApplySecondAudit',
      params,
      { preventRepeat: false }
    );
  },
  // 附件下载
  downLoadApplyFile: function (params) {
    return request.post(
      '/user-center/resourceFiling/downLoadApplyFile',
      params
    );
  },
  // 资源备案管理-审核历史操作记录
  queryFilingAuditLogList: function (params) {
    return request.post(
      '/user-center/resourceFiling/queryFilingAuditLogList',
      params
    );
  },

  // 资源备案管理- 全部操作记录查询
  queryFilingLogList: function (params) {
    return request.post(
      '/user-center/resourceFiling/queryFilingLogList',
      params
    );
  },
  // 资源备案管理-审核列表查询
  queryFilingPageInfo: function (params) {
    return request.post(
      '/user-center/resourceFiling/queryFilingPageInfo',
      params,
      { preventRepeat: false }
    );
  },
  // 资源备案管理-收费策略查看
  queryFilingRateList: function (params) {
    return request.post(
      '/user-center/resourceFiling/queryFilingRateList',
      params
    );
  },
  // 资源备案管理- 申请及查询列表
  queryFilingResourcePage: function (params) {
    return request.post(
      '/user-center/resourceFiling/queryFilingResourcePage',
      params,
      { preventRepeat: false }
    );
  },

  // 资源备案管理- 收费比例变更
  updateFilingRate: function (params) {
    return request.post('/user-center/resourceFiling/updateFilingRate', params);
  },

  // 全部解除备案
  secureAll: function (params) {
    return request.post('/user-center/filingRelation/secureAll', params);
  },

  // 部分解除备案
  securePart: function (params) {
    return request.post('/user-center/filingRelation/securePart', params);
  },

  // 批量增加
  batchAdd: function (params) {
    return request.post('/user-center/filingWhiteList/batchAdd', params);
  },
  // 批量删除
  batchDelete: function (params) {
    return request.post('/user-center/filingWhiteList/batchDelete', params);
  },
  // 是否在备案白名单中
  isWhiteList: function (params) {
    return request.post('/user-center/filingWhiteList/isWhiteList', params);
  },
  // 分页查询外部企业关联白名单
  queryExternalCompanyPage: function (params) {
    return request.post(
      '/user-center/filingWhiteList/queryExternalCompanyPage',
      params,
      { preventRepeat: false }
    );
  },
  // 分页查询白名单
  queryPage: function (params) {
    return request.post('/user-center/filingWhiteList/queryPage', params, {
      preventRepeat: false,
    });
  },
  // 查看当前登录人的岗位
  queryUserRole: function (params) {
    return request.post('/security/user/queryUserRole', params, {
      preventRepeat: false,
    });
  },
  // 获取比例   平台查询配置
  queryConfigList: function (params) {
    return request.post(
      '/transaction-center/orderConfig/queryConfigList',
      params,
      { preventRepeat: false }
    );
  },
  // 是否在备案白名单中
  isWhiteList: function (params) {
    return request.post('/user-center/filingWhiteList/isWhiteList', params, {
      preventRepeat: false,
    });
  },
};
export default server;
